import React, { Component } from 'react';
import {
  Modal,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  InputGroup,
} from 'react-bootstrap';
import { LANG } from '../../config';
import { notify } from 'react-notify-toast';

type IProps = {
  item: Object,
  onClose: () => void,
  onSave: (item: Object) => void,
  onRemove: () => void,
};

type IState = {
  key: string,
  left: string,
  right: string,
  options: Array<string>,
};

class ModalGrammar extends Component {
  constructor(props: IProps) {
    super(props);

    this.state = {
      key: '',
      left: '',
      right: '',
      tooltip: '',
      options: [''],
    };
  }

  componentWillReceiveProps(nextProps: IProps) {
    const { item } = nextProps;

    if (item) {
      const key = item.key || '';
      const left = item.left || '';
      const right = item.right || '';
      const tooltip = item.tooltip || '';
      const options = item.options || [''];

      this.setState({
        key,
        left,
        right,
        tooltip,
        options:
          options.length === 1 && options[0] === ''
            ? ['']
            : options.filter(value => value !== ''),
      });
    }
  }

  state: IState;

  handleOnSave(e) {
    const { onSave } = this.props;
    const { key, left, right, tooltip, options } = this.state;

    if (
      left.length === 0 ||
      right.length === 0 ||
      tooltip.length === 0 ||
      options[0].length === 0
    ) {
      notify.show('Please fill correctly!', 'warning', 3000);
      return;
    }

    onSave({
      key,
      left: left.trim(),
      right: right.trim(),
      tooltip: tooltip.trim(),
      options: options.map(i => i.trim()),
    });
  }

  handleOnRemove(e) {
    if (window.confirm('Are you sure?')) {
      const { onRemove } = this.props;
      onRemove();
    }
  }

  handleOnClose(e) {
    const { onClose } = this.props;

    onClose();
  }

  handleChangeOption(e, index) {
    const { options } = this.state;
    options[index] = e.target.value;
    this.setState({
      options,
    });
  }

  handleRemoveOption(e, index) {
    const { options } = this.state;
    options.splice(index, 1);
    this.setState({
      options,
    });
  }

  handleAddNextOption() {
    const { options } = this.state;
    options[options.length] = '';
    this.setState({
      options,
    });
  }

  props: IProps;

  render() {
    const { left, right, tooltip, options } = this.state;

    if (!this.props.item) {
      return <Modal show={false} />;
    }

    let title = 'Add new grammar item';
    if (this.props.item.key) {
      title = `Edit grammar item: ${this.props.item.left} ________ ${this.props.item.right}`;
    }

    return (
      <Modal
        show={this.props.item ? true : false}
        onHide={this.handleOnClose.bind(this)}
        backdrop={'static'}
      >
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FormGroup controlId='original'>
            <ControlLabel>Grammar item ({LANG.OTHER})</ControlLabel>
            <div style={{ display: 'flex' }}>
              <FormControl
                id='left'
                type='text'
                onChange={e => this.setState({ left: e.target.value })}
                value={left}
                style={{ float: 'left' }}
              />
              <strong style={{ padding: '6px 12px' }}>MISSING&nbsp;PART</strong>
              <FormControl
                id='right'
                type='text'
                onChange={e => this.setState({ right: e.target.value })}
                value={right}
                style={{ float: 'right' }}
              />
            </div>
          </FormGroup>
          <FormGroup controlId='tooltip'>
            <ControlLabel>Verb ({LANG.OTHER})</ControlLabel>
            <div style={{ display: 'flex' }}>
              <FormControl
                id='tooltip'
                type='text'
                onChange={e => this.setState({ tooltip: e.target.value })}
                value={tooltip}
              />
            </div>
          </FormGroup>
          <FormGroup>
            <ControlLabel>Missing part ({LANG.OTHER})</ControlLabel>
          </FormGroup>
          {options.map((value, index) => {
            return (
              <FormGroup key={`value-${index}`}>
                <InputGroup>
                  <FormControl
                    type='text'
                    onChange={e => this.handleChangeOption(e, index)}
                    value={value}
                  />
                  <InputGroup.Button>
                    <Button
                      disabled={index === 0}
                      onClick={e => this.handleRemoveOption(e, index)}
                    >
                      Remove
                    </Button>
                  </InputGroup.Button>
                </InputGroup>
              </FormGroup>
            );
          })}
          <FormGroup>
            <Button onClick={this.handleAddNextOption.bind(this)}>
              Add Next Option
            </Button>
          </FormGroup>
        </Modal.Body>
        <Modal.Footer>
          {this.props.item.key && (
            <Button
              onClick={this.handleOnRemove.bind(this)}
              bsStyle='danger'
              style={{ float: 'left' }}
            >
              Remove this grammar item
            </Button>
          )}
          <Button onClick={this.handleOnClose.bind(this)}>Close</Button>
          <Button bsStyle='primary' onClick={this.handleOnSave.bind(this)}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default ModalGrammar;



// WEBPACK FOOTER //
// ./src/pages/Grammar/ModalGrammar.js